import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import "../../assets/css/Modal.css";
export const UpdateConfirmationDialog = ({isOpen,onClose,onConfirm,title,message,showInactiveCheckbox = false,showNotes = false,}) => {
  const [includeInactive, setIncludeInactive] = useState(false);
  const [notes, setNotes] = useState("");
  if (!isOpen) return null;
  const handleConfirm = () => {
    onConfirm({ includeInactive, notes });
    setIncludeInactive(false);
    setNotes("");
  };
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-animate"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button className="button secondary" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        {/* BODY */}
        <div className="modal-body">
          <p>{message}</p>
          {showInactiveCheckbox && (
            <label className="inactive-checkbox">
              <input
                type="checkbox"
                checked={includeInactive}
                onChange={(e) => setIncludeInactive(e.target.checked)}
              />
              Also mark Inactive?
            </label>
          )}
          {showNotes && (
            <div className="modal-notes">
              <label>Additional Notes (Optional):</label>

              <textarea
                className="modal-textarea"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Enter any additional notes here..."
                rows={3}
              />
            </div>
          )}
        </div>
        {/* FOOTER */}
        <div className="modal-footer">
          <button className="button secondary" onClick={onClose}>
            Cancel
          </button>

          <button className="button primary" onClick={handleConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};
export default UpdateConfirmationDialog;
